<template>
  <section>
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span>本會創會董事長<br><sup>上</sup>淨<sup>下</sup>空老和尚<br>圓寂三週年追思紀念</span>
        </h3>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-img center :src="`${third_anniversary_file_url}/001.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">發菩提心 弘傳佛陀教育</h4>
        <h4 class="text-center">一向專念 彌陀六字洪名</h4>
        <b-img center :src="`${third_anniversary_file_url}/002.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">隨緣妙用無方 威儀住持有則</h4>
        <h4 class="text-center">柔和質直攝生 普代眾生受苦</h4>
        <b-img center :src="`${third_anniversary_file_url}/003.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">淨則無垢 六根都淨</h4>
        <h4 class="text-center">空即是色 四大皆空</h4>
        <b-img center :src="`${third_anniversary_file_url}/004.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4 class="text-center">
          淨空老和尚圓寂三週年追思紀念會
        </h4>
        <h5>紀念影片</h5>
        <p class="h6">
          <a href="javascript:void(0)" @click="showVideoPlayer(0)">緬懷淨空老和尚｜圓寂三週年追思紀念會</a>
        </p>
        <h5>2025-07-25「開幕式致詞」：</h5>
        <p class="h6">
          <a href="javascript:void(0)" @click="showVideoPlayer(1)">董事長 釋密寶法師 出席致詞</a>
        </p>
        <b-modal id="video-player" :title="currently_playing_video_title" centered size="lg">
          <video-player
            :videos="videos"
            :currently_playing_index="currently_playing_video_index"
            :playlist_autoplay="false"
            :show_playlist_ui="false"
            v-if="currently_playing_video_index !== -1"
          ></video-player>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import VideoPlayer from '@/components/players/VideoPlayer'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(ModalPlugin)

export default {
  name: "third-anniversary",
  props: {
    // 
  },
  data() {
    return {
      third_anniversary_file_url: 'https://www2.budaedu.org/official-website-data/founder/anniversary-memorial-ceremony/third-anniversary',
      currently_playing_video_index: -1,
      currently_playing_video_title: ''
    }
  },
  computed: {
    videos() {
      return [
        {
          name: '緬懷淨空老和尚｜圓寂三週年追思紀念會',
          description: '緬懷淨空老和尚｜圓寂三週年追思紀念會',
          url: `${this.third_anniversary_file_url}/memorial-video.mp4`
        },
        {
          name: '2025-07-25「開幕式致詞」：董事長 釋密寶法師 出席致詞',
          description: '2025-07-25「開幕式致詞」：董事長 釋密寶法師 出席致詞',
          url: `${this.third_anniversary_file_url}/2025-07-25-venerable-mi-bao-speech.mp4`
        }
      ]
    }
  },
  methods: {
    showVideoPlayer(video_to_be_played_index) {
      this.currently_playing_video_index = video_to_be_played_index
      this.currently_playing_video_title = this.videos[video_to_be_played_index].name
      this.$bvModal.show('video-player')
    },
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    VideoPlayer
  }
}
</script>